import styled from "styled-components"
import { Body } from "components/library/card/styled/"

const SquareBody = styled(Body)`
  padding: var(--spacing-x2);
`

export default SquareBody
